// @flow

import * as React from 'react';
import ProcurementTable from './Components/ProcurementTable';

type Props = {
  procurementItems: [],
  suppliers: [],
  editable: boolean,
  onClickAddProcurementItem: Function,
  onClickDeleteProcurementItem: Function,
  onClickShowCatalogPicker: Function,
  onChangeProcurementItemField: Function,
  onBlurProcurementItemField: Function,
  onClickSaveProcurementItems: Function,
}

export default class extends React.PureComponent<Props> {

  render () {

    const {
      procurementItems,
      suppliers,
      editable,
      onClickAddProcurementItem,
      onClickDeleteProcurementItem,
      onClickShowCatalogPicker,
      onChangeProcurementItemField,
      onBlurProcurementItemField,
      onClickSaveProcurementItems,
    } = this.props;

    return (
      <ProcurementTable
        procurementItems={procurementItems}
        suppliers={suppliers}
        editable={editable}
        onClickAddProcurementItem={onClickAddProcurementItem}
        onClickDeleteProcurementItem={onClickDeleteProcurementItem}
        onClickShowCatalogPicker={onClickShowCatalogPicker}
        onChangeProcurementItemField={onChangeProcurementItemField}
        onBlurProcurementItemField={onBlurProcurementItemField}
        onClickSaveProcurementItems={onClickSaveProcurementItems}
      />
    )
  }
}
